import PropTypes from "prop-types";
import { useCallback } from "react";
import get from "lodash/get";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg.jsx";
import { productShape } from "app/utils/propTypes";
import { pushTagOnProductViewButtonClick } from "app/utils/analytics";
import "@brand/Listing/Product/product-full-with-translucent-deal.scss";
import { OFFER_CONTRACT_TYPES } from "app/constants";
import BadgeList from "app/pages/.shared/ColoredProductBadge/BadgeList";
import ProductDestinationTitleContainer from "app/pages/.shared/ProductDestinationTitle/ProductDestinationTitleContainer";
import ProductTopBar from "@brand/Product/ProductTopBar";
import ProductNameWithCategory from "app/pages/.shared/ProductNameWithCategory/ProductNameWithCategory";
import ProductLinkContainer from "app/pages/.shared/ProductLink/ProductLinkContainer";
import IconRight from "app/pages/.shared/static/icons/IconRight";
import ProductDeal from "app/pages/.shared/Deal/ProductDeal";

const IMG_SIZES = {
	medium: { height: 550 },
	large: { height: 550 },
	xlarge: { height: 550 },
};

const IMG_CLOUDINARY_OPTIONS = ["c_fill"];

const ProductFullWithTranslucentDeal = ({ product = {}, position, showSmartDPOnRootUrl }) => {
	const handleProductClick = useCallback(() => {
		pushTagOnProductViewButtonClick(product, position + 1);
	}, [product.uri, position]);

	const mainPhoto = product.photos && product.photos[0];

	return (
		<div className="product-full-with-translucent-deal" data-testid="product-full">
			<div className="product-full-with-translucent-deal__header">
				<div className="product-full-with-translucent-deal__picture">
					<ProductLinkContainer
						handleProductClick={handleProductClick}
						productUri={product.uri}
						openOnNewTab={true}
					>
						<BackgroundProgressiveImg
							sizes={IMG_SIZES}
							cloudinaryOptions={IMG_CLOUDINARY_OPTIONS}
							src={mainPhoto && mainPhoto.url}
							thumbnail={mainPhoto && mainPhoto.thumbnail}
						/>
					</ProductLinkContainer>

					<div className="product-full-with-translucent-deal__topbar">
						<ProductTopBar
							product={product}
							showSmartDPOnRootUrl={showSmartDPOnRootUrl}
						/>
					</div>

					<div className="product-full-with-translucent-deal__deal">
						<ProductDeal
							isRental={product.contractType === OFFER_CONTRACT_TYPES.RENTAL}
							includeOfferWithFlight={product.includeOfferWithFlight}
							publicPrice={get(product, "fromPriceType.publicPrice")}
							price={get(product, "fromPriceType.price")}
							duration={get(product, "fromPriceType.numberOfNights")}
							hour={get(product, "expiration.hour")}
							day={get(product, "expiration.day")}
							type={get(product, "fromPriceType.type")}
							value={get(product, "fromPriceType.value")}
						/>
					</div>
				</div>
			</div>
			<div className="product-full-with-translucent-deal__footer">
				<div className="product-full-with-translucent-deal__info product-full-with-translucent-deal__info--left">
					<div className="product-full-with-translucent-deal__main">
						<ProductDestinationTitleContainer
							className="product-full-with-translucent-deal__destination"
							country={product.country}
							region={product.region}
							resort={product.resort}
						>
							{product.badges && product.badges.length > 0 ? (
								<div className="product-full-with-translucent-deal__badges">
									<BadgeList badges={product.badges} />
								</div>
							) : (
								false
							)}
						</ProductDestinationTitleContainer>
						<ProductNameWithCategory
							categoryType={product.categoryType}
							category={product.category}
							name={product.name}
						/>
					</div>
				</div>

				<div className="product-full-with-translucent-deal__info product-full-with-translucent-deal__info--right">
					<div className="product-full-with-translucent-deal__action">
						<ProductLinkContainer
							handleProductClick={handleProductClick}
							productUri={product.uri}
							openOnNewTab={true}
						>
							<IconRight width={20} height={20} />
						</ProductLinkContainer>
					</div>
				</div>
			</div>
		</div>
	);
};

ProductFullWithTranslucentDeal.propTypes = {
	position: PropTypes.number,
	product: productShape,
	showSmartDPOnRootUrl: PropTypes.bool,
};

export default ProductFullWithTranslucentDeal;
